export const mediaList = [
  {
    id: 'm1',
    title: '星际回响',
    enTitle: 'Interstellar Echo',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20station%20orbiting%20a%20glowing%20ringed%20planet%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-m1-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20station%20orbiting%20a%20glowing%20ringed%20planet%2C%20cinematic%20wide%20shot%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20moody%20atmosphere%2C%20no%20text&width=1600&height=900&seq=yz-m1-banner&orientation=landscape',
    year: 2025,
    region: '中国',
    genres: ['科幻', '剧情', '冒险'],
    rating: 9.1,
    director: '陈屿',
    cast: ['林知遥', '周牧野', '苏晚'],
    duration: '148分钟',
    episodes: 0,
    summary:
      '当人类最后一艘深空探测船在木星轨道失联，工程师林知遥带着一段无法解释的"回响"信号重返故地。她发现，信号并非来自外星文明，而是来自二十年后的自己。一场关于时间、记忆与选择的星际迷局就此展开。',
    hot: 9860,
    tags: ['科幻', '时空', '国产大片', '林知遥'],
  },
  {
    id: 'm2',
    title: '暗夜追凶',
    enTitle: 'Nightfall Chase',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=noir%20detective%20silhouette%20in%20a%20rainy%20neon%20city%20street%20at%20night%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-m2-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=noir%20detective%20silhouette%20walking%20through%20a%20rainy%20neon%20city%20street%20at%20night%2C%20cinematic%20wide%20shot%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20moody%20atmosphere%2C%20no%20text&width=1600&height=900&seq=yz-m2-banner&orientation=landscape',
    year: 2024,
    region: '中国香港',
    genres: ['犯罪', '悬疑', '惊悚'],
    rating: 8.6,
    director: '麦兆行',
    cast: ['古天乐', '刘青云', '林家栋'],
    duration: '132分钟',
    episodes: 0,
    summary:
      '一宗沉寂十年的连环失踪案重启调查，退休警探程志远被迫重回警队。随着线索层层剥开，他发现自己当年亲手结案的那一页，正是整条黑暗链条的起点。',
    hot: 8720,
    tags: ['犯罪', '悬疑', '港片', '警匪'],
  },
  {
    id: 'm3',
    title: '山海秘境',
    enTitle: 'The Hidden Realm',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=mythical%20ancient%20mountains%20with%20floating%20islands%20and%20swirling%20mist%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-m3-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=mythical%20ancient%20mountains%20with%20floating%20islands%20and%20swirling%20mist%2C%20cinematic%20wide%20epic%20landscape%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=yz-m3-banner&orientation=landscape',
    year: 2025,
    region: '中国',
    genres: ['奇幻', '冒险', '古装'],
    rating: 8.3,
    director: '乌尔行',
    cast: ['陈坤', '周迅', '易烊千玺'],
    duration: '155分钟',
    episodes: 0,
    summary:
      '古籍记载的山海秘境重现人间，一位年轻的绘卷修复师意外唤醒了沉睡千年的守山人。为了阻止秘境崩塌，两人踏上了一场穿越古今奇幻山河的冒险。',
    hot: 8230,
    tags: ['奇幻', '冒险', '古装', '国风'],
  },
  {
    id: 'm4',
    title: '时间旅人',
    enTitle: 'The Time Traveler',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=lone%20figure%20walking%20through%20a%20glowing%20time%20portal%20tunnel%20of%20light%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-m4-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=lone%20figure%20walking%20through%20a%20glowing%20time%20portal%20tunnel%20of%20light%2C%20cinematic%20wide%20shot%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=yz-m4-banner&orientation=landscape',
    year: 2024,
    region: '美国',
    genres: ['科幻', '爱情', '剧情'],
    rating: 8.8,
    director: 'Alexander Reed',
    cast: ['Emma Stone', 'John David'],
    duration: '126分钟',
    episodes: 0,
    summary:
      '一位物理学家发明了只能回到过去七分钟的装置。为了挽回一场意外，他一次次穿越，却发现每一次微小的改变，都在悄悄改写他与爱人的未来。',
    hot: 7950,
    tags: ['科幻', '爱情', '时空', '好莱坞'],
  },
  {
    id: 'm5',
    title: '春日来信',
    enTitle: 'Spring Letters',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20couple%20standing%20in%20a%20spring%20flower%20field%20at%20golden%20hour%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20soft%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20warm%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-m5-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=romantic%20couple%20standing%20in%20a%20spring%20flower%20field%20at%20golden%20hour%2C%20cinematic%20wide%20shot%2C%20soft%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20warm%20atmosphere%2C%20no%20text&width=1600&height=900&seq=yz-m5-banner&orientation=landscape',
    year: 2025,
    region: '日本',
    genres: ['爱情', '剧情', '治愈'],
    rating: 8.9,
    director: '岩井俊行',
    cast: ['新垣结衣', '佐藤健'],
    duration: '118分钟',
    episodes: 0,
    summary:
      '在小镇邮局工作的女孩，每年春天都会收到一封没有寄件人的信。直到某一年，信中的约定终于被兑现，一段跨越十年的温柔暗恋也随之揭开。',
    hot: 7680,
    tags: ['爱情', '治愈', '日系', '暗恋'],
  },
  {
    id: 'm6',
    title: '孤城',
    enTitle: 'The Lonely Fortress',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=ruined%20ancient%20fortress%20city%20in%20dust%20and%20smoke%20at%20dusk%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20moody%20epic%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-m6-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=ruined%20ancient%20fortress%20city%20in%20dust%20and%20smoke%20at%20dusk%2C%20cinematic%20wide%20epic%20battlefield%20landscape%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=yz-m6-banner&orientation=landscape',
    year: 2023,
    region: '中国大陆',
    genres: ['战争', '历史', '剧情'],
    rating: 8.5,
    director: '冯小宁',
    cast: ['张译', '段奕宏', '王砚辉'],
    duration: '141分钟',
    episodes: 0,
    summary:
      '战火中的一座边陲孤城，守将奉命死守三日。城破之前，他与城中百姓共同书写了一段关于信念与牺牲的悲壮史诗。',
    hot: 7010,
    tags: ['战争', '历史', '剧情', '主旋律'],
  },
  {
    id: 'm7',
    title: '深海迷航',
    enTitle: 'Deep Sea Voyage',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=submarine%20descending%20into%20a%20bioluminescent%20deep%20ocean%20trench%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-m7-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=submarine%20descending%20into%20a%20bioluminescent%20deep%20ocean%20trench%2C%20cinematic%20wide%20underwater%20shot%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=yz-m7-banner&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    genres: ['科幻', '惊悚', '冒险'],
    rating: 7.9,
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健'],
    duration: '137分钟',
    episodes: 0,
    summary:
      '一支深海科考队深入马里亚纳海沟执行勘探任务，却在万米深处探测到不属于任何已知生物的心跳频率。当通讯中断，深海的秘密开始反噬每一个靠近它的人。',
    hot: 6890,
    tags: ['科幻', '惊悚', '深海', '灾难'],
  },
  {
    id: 'm8',
    title: '迷雾侦探',
    enTitle: 'Mist Detective',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=shadowy%20detective%20holding%20a%20magnifying%20glass%20in%20a%20foggy%20alley%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-m8-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=shadowy%20detective%20holding%20a%20magnifying%20glass%20in%20a%20foggy%20alley%2C%20cinematic%20wide%20shot%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=yz-m8-banner&orientation=landscape',
    year: 2025,
    region: '英国',
    genres: ['悬疑', '推理', '犯罪'],
    rating: 8.7,
    director: 'Christopher Bain',
    cast: ['Benedict C', 'Olivia C'],
    duration: '122分钟',
    episodes: 0,
    summary:
      '浓雾笼罩的海港小镇接连发生离奇案件，退休推理小说家被卷入其中。他发现，凶手似乎正按照自己书中未发表的手稿一一作案。',
    hot: 6540,
    tags: ['悬疑', '推理', '英剧改编', '侦探'],
  },
  {
    id: 't1',
    title: '长安风云',
    enTitle: 'Changan Chronicles',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20imperial%20palace%20city%20with%20glowing%20lanterns%20at%20night%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20opulent%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-t1-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20imperial%20palace%20city%20with%20glowing%20lanterns%20at%20night%2C%20cinematic%20wide%20epic%20shot%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20opulent%20atmosphere%2C%20no%20text&width=1600&height=900&seq=yz-t1-banner&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['古装', '权谋', '历史'],
    rating: 9.2,
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围'],
    duration: '45分钟/集',
    episodes: 36,
    summary:
      '上元灯节前夕，长安城被一场突如其来的阴谋笼罩。一位死囚与一位少年，被命运推向拯救这座城的风暴中心。三十六时辰之内，一切将见分晓。',
    hot: 9980,
    tags: ['古装', '权谋', '历史', '长安', '雷佳音'],
  },
  {
    id: 't2',
    title: '都市浮生',
    enTitle: 'City Lives',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=modern%20city%20skyline%20with%20young%20people%20walking%20the%20streets%20at%20night%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20urban%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-t2-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=modern%20city%20skyline%20with%20young%20people%20walking%20the%20streets%20at%20night%2C%20cinematic%20wide%20shot%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20urban%20atmosphere%2C%20no%20text&width=1600&height=900&seq=yz-t2-banner&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    genres: ['都市', '情感', '剧情'],
    rating: 8.4,
    director: '汪俊',
    cast: ['黄磊', '海清', '白宇'],
    duration: '42分钟/集',
    episodes: 40,
    summary:
      '四个性格迥异的年轻人在同一栋写字楼里打拼，他们的梦想、爱情与挣扎，构成了这座都市最真实的浮世绘。',
    hot: 8110,
    tags: ['都市', '情感', '职场', '群像'],
  },
  {
    id: 't3',
    title: '星海远征',
    enTitle: 'Expedition to the Stars',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=a%20fleet%20of%20spaceships%20traveling%20across%20a%20starry%20galaxy%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20epic%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-t3-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=a%20fleet%20of%20spaceships%20traveling%20across%20a%20starry%20galaxy%2C%20cinematic%20wide%20epic%20shot%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=yz-t3-banner&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['科幻', '冒险', '剧情'],
    rating: 8.6,
    director: '张小北',
    cast: ['张震', '倪妮', '王传君'],
    duration: '48分钟/集',
    episodes: 24,
    summary:
      '为了寻找适合人类移民的新家园，一支远征舰队驶向未知星系。在漫长的星际航行中，船员们要面对的不只是宇宙的凶险，还有人心深处的孤独。',
    hot: 8560,
    tags: ['科幻', '冒险', '星际', '群像'],
  },
  {
    id: 't4',
    title: '医者仁心',
    enTitle: 'Healer’s Heart',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=doctor%20in%20a%20bright%20modern%20hospital%20corridor%20looking%20hopeful%2C%20cinematic%20premium%20entertainment%20poster%20visual%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20clean%20atmosphere%2C%20no%20text&width=600&height=900&seq=yz-t4-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=doctor%20in%20a%20bright%20modern%20hospital%20corridor%20looking%20hopeful%2C%20cinematic%20wide%20shot%2C%20dramatic%20lighting%2C%20deep%20midnight%20blue%20and%20warm%20orange%20color%20grading%2C%20highly%20detailed%2C%20clean%20atmosphere%2C%20no%20text&width=1600&height=900&seq=yz-t4-banner&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    genres: ['医疗', '剧情', '现实'],
    rating: 8.8,
    director: '刘俊杰',
    cast: ['靳东', '海清', '袁泉'],
    duration: '45分钟/集',
    episodes: 32,
    summary:
      '急诊科主任带着一群年轻医生坚守在生死一线，每一台手术背后，都是一个家庭的悲欢。他们救的不只是病人，还有彼此对这份职业的信念。',
    hot: 7420,
    tags: ['医疗', '现实', '职场', '群像'],
  },
];